import homeHero from "./home_hero.png";
import homeCards from "./home_cards.png";
import feature from "./feature.png";
import expo from "./expo.png";
import expo02 from "./expo02.png";
import javascript from "./javascript.png";
import react from "./react.png";
import scene from "./scene.png";
import mockup from "./mockup.png";
import bhl from "./bhl-logo.png";
import bhlhero from "./bhlhero.jpg";
import datacenter from "./datacenter.png";
import securityb from "./securityb.png";
import police from "./police.png";
import pepper from "./pepper.png";
import metal from "./metal.png";
import taser from "./taser.png";
import gadgets from "./gadgets.png";
import robocop from "./robocop.png";
import detail from "./detail.png";
import click from "./click.png";
import zeus from "./zeus.png";

export default {
  homeHero,
  homeCards,
  feature,
  expo,
  expo02,
  javascript,
  react,
  scene,
  mockup,
  bhl,
  bhlhero,
  datacenter,
  securityb,
  police,
  pepper,
  metal,
  taser,
  gadgets,
  robocop,
  detail,
  click,
  zeus,
};
